import Profile from "src/sections/Profile/Profile";

export default Profile;
